import { createStyles } from 'antd-style'

import { EaRocketIcon } from '@eastcoal/icon/EaRocketIcon'
import { EaSafeIcon } from '@eastcoal/icon/EaSafeIcon'
import { EaServicePeopleIcon } from '@eastcoal/icon/EaServicePeopleIcon'

import { LayoutContainer } from '../../Container'

const useStyles = createStyles(({ token }) => ({
  wrapper: {
    backgroundColor: token.colorPrimary
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBlock: token.paddingSM
  },
  item: {
    display: 'inline-grid',
    gridTemplateColumns: 'repeat(2,auto)',
    gridTemplateRows: 'repeat(2,auto)',
    gridTemplateAreas: `
      'a b'
      'a c'
    `,
    columnGap: token.paddingXS,
    color: token.colorWhite
  },
  icon: {
    gridArea: 'a',
    fontSize: token.fontSizeHeading1
  },
  title: {
    gridArea: 'b',
    fontSize: token.fontSizeHeading5
  },
  description: {
    gridArea: 'c',
    fontSize: token.fontSize,
    opacity: 0.8
  }
}))

const items = [
  {
    title: '高效交易',
    description: '丰富品类资源，众多活跃会员，促成高效交易',
    Icon: EaRocketIcon
  },
  {
    title: '安全保障',
    description: '会员资质认证，交易流程监督，成交安心有保障',
    Icon: EaSafeIcon
  },
  {
    title: '优质服务',
    description: '专业客户经理，一对一贴心指导，服务更优质',
    Icon: EaServicePeopleIcon
  }
]

export const Introduction = () => {
  const { styles } = useStyles()

  return (
    <div className={styles.wrapper}>
      <LayoutContainer className={styles.container}>
        {items.map(({ title, description, Icon }) => (
          <div key={title} className={styles.item}>
            <Icon className={styles.icon} />
            <span className={styles.title}>{title}</span>
            <span className={styles.description}>{description}</span>
          </div>
        ))}
      </LayoutContainer>
    </div>
  )
}
